type FlightOrderItemId = string

function getFlightDetailsByOrderItems(order: App.Order, flightDetails: App.ApiStateRecord<{ flight?: App.FlightOrderItemDetails }>): Record<FlightOrderItemId, App.FlightOrderItemDetails> | undefined {
  if (!Object.keys(flightDetails).length) return

  const flightItemIds = order?.flightItems.map(item => item.id) || []

  const flightDetailsByItem: Record<FlightOrderItemId, App.FlightOrderItemDetails> = Object.entries(flightDetails)
    .filter(([flightItemId, flightDetail]) => {
      if (flightDetail?.fetching) return false
      return flightItemIds.includes(flightItemId)
    })
    .reduce((acc, [flightItemId, flightDetail]) => {
      return {
        ...acc,
        [flightItemId]: flightDetail?.flight,
      }
    }, {})

  // Return undefined when no resolved details (e.g. still loading) so callers don't treat empty {} as "have data"
  return Object.keys(flightDetailsByItem).length > 0 ? flightDetailsByItem : undefined
}

export default getFlightDetailsByOrderItems
